import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { MaintenanceListPage } from "@/pages/dashboard/maintenance/list";

export const Route = createFileRoute("/_main/dashboard/maintenance/")({
  component: () => (
    <RequirePermission action="maintenance.read">
      <MaintenanceListPage />
    </RequirePermission>
  ),
});
